import { getProjectById, getProjects, getTags } from "@/lib/api/projects"
import { useQuery } from "@tanstack/react-query"

export function useProjects(setSlug: string = "default") {
  const isDefaultSet = setSlug === "default"

  return useQuery({
    queryKey: ["projects", setSlug],
    queryFn: () => getProjects(setSlug),
    staleTime: isDefaultSet ? 5 * 60 * 1000 : 0,
    refetchOnMount: isDefaultSet ? true : "always",
    retry: isDefaultSet ? 3 : false,
  })
}

export function useProject(id: string | undefined) {
  return useQuery({
    queryKey: ["project", id],
    queryFn: () => (id ? getProjectById(id) : null),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}

export function useRandomProjects(count: number = 3) {
  const { data: projects, ...rest } = useProjects()

  const randomProjects = projects ? [...projects].sort(() => Math.random() - 0.5).slice(0, count) : []

  return { data: randomProjects, ...rest }
}

export function useTags() {
  return useQuery({
    queryKey: ["tags"],
    queryFn: getTags,
    staleTime: 5 * 60 * 1000,
  })
}
